import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import initialState from "../initial-state";

const loadingScreen = createSlice({
  name: "loadingScreen",
  initialState: initialState.loadingScreen,
  reducers: {
    showLoadingScreen(state) {
      return { ...state, visible: true };
    },
    hideLoadingScreen(state) {
      return { ...state, visible: false };
    },
    setProggress(state, action: PayloadAction<number>) {
      return { ...state, progress: Math.min(action.payload, 100) };
    },
  },
});

export const { showLoadingScreen, hideLoadingScreen, setProggress } =
  loadingScreen.actions;

export default loadingScreen;
